import { KYMW9009Model } from '../kymw9009.model';
import { GetUserClassManagementModel } from '../vo/get-user-class-management.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';

/**
 * ユーザ階層管理取得コマンド
 * サーバーにOkta情報情報をリクエストし、結果を表示する。
 *
 * @export GetUserClassManagementListService
 * @class GetUserClassManagementListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetUserClassManagementListService extends PlessJsonResponderSub<any> {
  private model: KYMW9009Model = null;
  private vo: GetUserClassManagementModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetUserClassManagementListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        GetUserClassManagementList: {
          condition: {
            ClassCode: this.vo.ClassCode,
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9009Model} model モデルクラス
   * @param {GetUserClassManagementModel} vo ユーザ階層管理一覧取得条件VO
   * @memberof GetUserClassManagementListService
   */
  execute(model: KYMW9009Model, vo: GetUserClassManagementModel) {
    this.model = model;
    this.vo = vo;
    this.send('getUserClassManagementList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetOktaInfomationListService
   */
  success(data: any) {
    // データグリッド「ユーザ階層管理一覧」を更新
    this.model.updateUserClassList(data, this.vo);
  }
}
